import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

function RegistrationPage({ onRegister }) {
  const [formData, setFormData] = useState({
    fullName: '',
    age: '',
    gender: '',
    email: '',
    privacyConsent: false,
    dataProcessingConsent: false,
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('emotionSurveyUserId')) {
      navigate('/experiment-intro');
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!formData.fullName || !formData.age || !formData.gender || !formData.email) {
        setError('Пожалуйста, заполните все поля.');
        setIsLoading(false);
        return;
    }

    // Валидация возраста
    const ageNum = parseInt(formData.age, 10);
    if (isNaN(ageNum) || ageNum < 18 || ageNum > 99) {
      setError('Возраст должен быть числом от 18 до 99.');
      setIsLoading(false);
      return;
    }

    if (!formData.privacyConsent || !formData.dataProcessingConsent) {
      setError('Необходимо дать согласие на обработку данных и политику конфиденциальности.');
      setIsLoading(false);
      return;
    }

    try {
      // Отправляем возраст как число
      const dataToSubmit = { ...formData, age: ageNum };
      const response = await registerUser(dataToSubmit);
      onRegister(response.data.userId);
      localStorage.removeItem('emotionSurveyVideoQueue');
      localStorage.removeItem('emotionSurveyCurrentVideoIndex');
      localStorage.removeItem('emotionSurveyCurrentTaskVideo');
      localStorage.removeItem('emotionSurveyCurrentTaskNumber');
      navigate('/experiment-intro');
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка регистрации. Попробуйте еще раз.');
      console.error("Registration Error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-container">
      <h1>Регистрация для участия в эксперименте</h1>
      <form onSubmit={handleSubmit} className="registration-form">
        {/* ... остальные поля формы ... */}
        <label>ФИО: <input type="text" name="fullName" value={formData.fullName} onChange={handleChange} required /></label>
        <label>Возраст (18-99): <input type="number" name="age" value={formData.age} onChange={handleChange} required /></label> {/* Можно добавить min/max атрибуты для HTML5 валидации, но JS проверка надежнее */}
        <label>Пол:
          <select name="gender" value={formData.gender} onChange={handleChange} required>
            <option value="">Выберите...</option>
            <option value="мужской">Мужской</option>
            <option value="женский">Женский</option>
          </select>
        </label>
        <label>Email: <input type="email" name="email" value={formData.email} onChange={handleChange} required /></label>
        <div className="consent-checkbox">
          <input type="checkbox" id="privacyConsent" name="privacyConsent" checked={formData.privacyConsent} onChange={handleChange} />
		  <label htmlFor="privacyConsent">
            Я согласен(на) с <Link to="/privacy-policy">политикой конфиденциальности</Link>.
          </label>        </div>
        <div className="consent-checkbox">
          <input type="checkbox" id="dataProcessingConsent" name="dataProcessingConsent" checked={formData.dataProcessingConsent} onChange={handleChange} />
          <label htmlFor="dataProcessingConsent">
            Я согласен(на) на <Link to="/data-processing-policy">обработку персональных данных</Link>.
          </label>
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" disabled={isLoading} className="app-header-button"> {/* Используем общий стиль кнопки */}
          {isLoading ? <LoadingSpinner size="small" /> : 'Зарегистрироваться и начать'}
        </button>
      </form>
    </div>
  );
}

export default RegistrationPage;